import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import { Link } from 'react-router-dom';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onPageChange,       // <-- FIX: receive the dedicated handler
  handleDrawerOpen,
  deleteRecord,
}) => {
  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount={totalRecord}
      // Support both controlled & legacy props your wrapper might use:
      currentPage={dataFilter?.page}
      initialPage={dataFilter?.page}
      perPage={dataFilter?.limit}
      per_page={dataFilter?.limit}
      // The table will call us with just (pageNumber)
      onChangePage={(pageNum) => onPageChange?.(Number(pageNum))}
      // If your TableWrapServerSide also supports onChangePerPage, wire it here:
      // onChangePerPage={(limit) => onPerPageChange?.(Number(limit))}
    >
      {dataSource && dataSource.length > 0 ? (
        dataSource.map((data) => (
          <tr className="db-table-body-tr" key={data._id}>
            <td className="db-table-body-td">{data.name || 'N/A'}</td>
            <td className="db-table-body-td">{data.item_category?.name || 'N/A'}</td>
            <td className="db-table-body-td">
              {data.item_category?.isPerishable ? (
                <span className="text-emerald-600">Yes</span>
              ) : (
                <span className="text-gray-500">No</span>
              )}
            </td>
            <td className="db-table-body-td">
              {data.price !== undefined && data.price !== null ? `$${data.price}` : 'N/A'}
            </td>
            <td className="db-table-body-td">
              {String(data.status) === '1' ? (
                <span className="active">Active</span>
              ) : (
                <span className="inactive">Inactive</span>
              )}
            </td>
            <td className="db-table-body-td hidden-print hidden-print-remove">
              <div className="flex justify-start items-center gap-1.5">
                <PermissionCheck permission={'View_items'}>
                  <Link to={`/admin/item/show/${data._id}`}>
                    <button type="button" className="db-table-action view">
                      <i className="lab lab-view"></i>
                      <span className="db-tooltip">view</span>
                    </button>
                  </Link>
                </PermissionCheck>
                <PermissionCheck permission={'update_items'}>
                  <button
                    type="button"
                    className="db-table-action edit"
                    onClick={() => handleDrawerOpen(data._id)}
                  >
                    <i className="lab lab-edit-line"></i>
                    <span className="db-tooltip">edit</span>
                  </button>
                </PermissionCheck>
                <PermissionCheck permission={'Delete_items'}>
                  <button
                    type="button"
                    className="db-table-action delete"
                    onClick={() => deleteRecord(data._id)}
                  >
                    <i className="lab lab-delete"></i>
                    <span className="db-tooltip">delete</span>
                  </button>
                </PermissionCheck>
              </div>
            </td>
          </tr>
        ))
      ) : (
        <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
      )}
    </TableWrapServerSide>
  );
};

export default DataTable;
